"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const isEqual_1 = __importDefault(require("lodash/isEqual"));
const react_1 = require("react");
const useDebounce = (newValue, debounceMs = 0) => {
    const [value, setValue] = (0, react_1.useState)(newValue);
    const memo = (0, react_1.useRef)();
    if (!(0, isEqual_1.default)(memo.current, newValue)) {
        memo.current = newValue;
    }
    const { current } = memo;
    (0, react_1.useEffect)(() => {
        let handle;
        if (debounceMs > 0 && !(0, isEqual_1.default)(value, current)) {
            handle = setTimeout(() => {
                setValue(current);
            }, debounceMs);
        }
        return () => {
            if (handle) {
                clearTimeout(handle);
                handle = null;
            }
        };
    }, [current, value, setValue, debounceMs]);
    return [debounceMs > 0 ? value : memo.current, memo.current];
};
exports.default = useDebounce;
//# sourceMappingURL=useDebounce.js.map